import { IOrderStatus } from '../../types/newbuilding/flatViewOrderInfo';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewbuildingActionTypes {
  SetFavorite = 'newbuilding/setFavorite',
  SetFlatViewOrder = 'newbuilding/setFlatViewOrder',
}

export type TSetFavorite = ITypedReduxAction<ENewbuildingActionTypes.SetFavorite, boolean>;

export type TSetFlatViewOrder = ITypedReduxAction<ENewbuildingActionTypes.SetFlatViewOrder, IOrderStatus>;

/**
 * Redux action, который записывает в store статус избранного
 * @param state boolean
 */
export const setFavorite: (state: boolean) => TSetFavorite = actionGenerator<
  ENewbuildingActionTypes.SetFavorite,
  boolean
>(ENewbuildingActionTypes.SetFavorite);

export const setFlatViewOrder = actionGenerator<ENewbuildingActionTypes.SetFlatViewOrder, IOrderStatus>(
  ENewbuildingActionTypes.SetFlatViewOrder,
);
